import { formatDateString } from "@/lib/dates/formatters";
import { SpacingValues } from "@/lib/utils/SpacingValues";
import {
  CopyHeadAgreementTargetCustomerQuery,
  HeadAgreementStatusCode,
} from "@/gql/graphql";
import { Box, Heading, Indent, Row, Spacing, Text } from "@stenajs-webui/core";
import { PrimaryButton } from "@stenajs-webui/elements";
import * as React from "react";
import { useNavigate } from "react-router";
import { CopyHeadAgreementFormModel } from "../../model/CopyHeadAgreementFormModel";
import { HeadAgreement } from "../../types";

interface CopyFromOtherCustomerResultPaneProps {
  loading: boolean;
  success: boolean;
  copyFromHeadAgreement: HeadAgreement;
  copyToHeadAgreement:
    | CopyHeadAgreementTargetCustomerQuery["productPrice"]["headAgreement"]["byId"]
    | undefined;
  copyToCustomerPath: string;
  formModel: CopyHeadAgreementFormModel;
}

export const CopyHaFromOtherCustomerResultPane: React.FC<
  CopyFromOtherCustomerResultPaneProps
> = ({
  loading,
  success,
  copyFromHeadAgreement,
  copyToHeadAgreement,
  copyToCustomerPath,
  formModel,
}) => {
  const navigate = useNavigate();
  const copyFromValidStart = formatDateString(
    new Date(copyFromHeadAgreement.valid.start?.isoString ?? "")
  );
  const copyFromValidEnd = formatDateString(
    new Date(copyFromHeadAgreement.valid.end?.isoString ?? "")
  );
  const copyToValidStart = formatDateString(
    new Date(
      copyToHeadAgreement
        ? copyToHeadAgreement?.valid.start?.isoString ?? ""
        : formModel.valid.startDate ?? ""
    )
  );
  const copyToValidEnd = formatDateString(
    new Date(
      copyToHeadAgreement
        ? copyToHeadAgreement?.valid.end?.isoString ?? ""
        : formModel.valid.endDate ?? ""
    )
  );
  const copyToName = copyToHeadAgreement
    ? copyToHeadAgreement?.name
    : formModel.name;
  const copyToStatusCode = copyToHeadAgreement
    ? copyToHeadAgreement?.statusCode
    : formModel.statusCode ?? HeadAgreementStatusCode.Pending;

  return (
    <Box>
      <Row alignItems={"center"}>
        <Box>
          <Heading variant="h4">Copied to</Heading>
          <Spacing num={0.5} />
          <Text>
            {`${copyToValidStart} - ${copyToValidEnd} - ${copyToName} - ${copyToStatusCode}`}
          </Text>
        </Box>
        <Indent num={4} />
        <Box>
          <Heading variant="h4">Copied from</Heading>
          <Spacing num={0.5} />
          <Text>
            {`${copyFromValidStart} - ${copyFromValidEnd} - ${copyFromHeadAgreement.name} - ${copyFromHeadAgreement.statusCode}`}
          </Text>
        </Box>
      </Row>
      <Spacing num={SpacingValues.TWELVE} />
      <Row justifyContent={"flex-end"}>
        <PrimaryButton
          onClick={() => navigate(copyToCustomerPath)}
          label={"Close"}
          disabled={loading && !success}
        />
      </Row>
    </Box>
  );
};
